import styled from 'styled-components';
import { FONTS, COLORS, SIZE } from '@app/src/ui';
import { Button } from '@app/src/common/Button';

export const Container = styled.div`
  max-width: 520px;
  margin: 80px auto 105px;
  text-align: center;
  padding: 0 15px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    padding: 0;
  }
`;

export const Img = styled.img`
  display: inline-block;
  margin: 0 0 30px;
  width: 180px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    width: 250px;
  }
`;

export const Title = styled.h2`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 20px;
  margin: 0 0 25px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 24px;
  }
`;

export const Message = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 18px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 20px;
  }
`;

export const ButtonWrapper = styled(Button)`
  margin: 15px auto 55px;
  span {
    font-weight: 600;
  }
`;

export const Text = styled.p`
  font-family: ${FONTS.OPEN_SANS};
  font-size: 13px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

export const CentralHelp = styled.a`
  color: ${COLORS.BLACK};
  font-size: 13px;
  font-weight: 600;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;